module.exports = __webpack_public_path__ + "static/media/avatarPlaceHolder.62d7c01c.svg";